const isDarkTheme = () => {
  if (typeof document === 'undefined') return false;
  return document.documentElement.getAttribute('data-bs-theme') === 'dark';
};

const getOptionHoverBg = () => (isDarkTheme() ? 'var(--bs-gray-700)' : 'var(--bs-gray-200)');
const getOptionHoverColor = () => (isDarkTheme() ? 'white' : 'var(--bs-gray-900)');

export const customSelectStyles = {
  control: (provided, state) => ({
    ...provided,
    backgroundColor: 'var(--bs-body-bg)',
    borderColor: state.isFocused ? 'var(--bs-primary)' : 'var(--bs-border-color)',
    color: 'var(--bs-body-color)',
    '&:hover': {
      borderColor: 'var(--bs-primary)',
    },
    boxShadow: state.isFocused ? '0 0 0 0.2rem rgba(var(--bs-primary-rgb), 0.25)' : provided.boxShadow,
  }),
  menu: (provided) => ({
    ...provided,
    backgroundColor: 'var(--bs-body-bg)',
    borderColor: 'var(--bs-border-color)',
  }),
  option: (provided, state) => {
    const hoverBg = getOptionHoverBg();
    const hoverColor = getOptionHoverColor();

    return {
      ...provided,
      backgroundColor: state.isSelected ? 'var(--bs-primary)' : state.isFocused ? hoverBg : 'var(--bs-body-bg)',
      color: state.isSelected ? 'white' : state.isFocused ? hoverColor : 'var(--bs-emphasis-color)',
      '&:hover': {
        backgroundColor: state.isSelected ? 'var(--bs-primary)' : hoverBg,
        color: state.isSelected ? 'white' : hoverColor,
      },
    };
  },
  singleValue: (provided) => ({
    ...provided,
    color: 'var(--bs-body-color)',
  }),
  input: (provided) => ({
    ...provided,
    color: 'var(--bs-body-color)',
  }),
  placeholder: (provided) => ({
    ...provided,
    color: 'var(--bs-secondary-color)',
  }),
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: 'var(--bs-secondary-bg)',
    color: 'var(--bs-body-color)',
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: 'var(--bs-body-color)',
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: 'var(--bs-body-color)',
    '&:hover': {
      backgroundColor: 'var(--bs-danger)',
      color: 'white',
    },
  }),
};